const NotaHelper = {
    HasImage(nota) {
        return nota.imagenes instanceof Array
            && nota.imagenes.length > 0
            && !!nota.imagenes[0].src;
    }
};

export default NotaHelper;


// WEBPACK FOOTER //
// ./Statics/scripts/Nota/NotaHelper.js